<template>
  <div class="glance">
    <div class="header"><h2>{{ header.label }} - {{ displayHeader }}</h2></div>
    <detail-card :layout="layout" :detail-body="glanceData" :editable="[]" :keep-card-container="false"></detail-card>
  </div>
</template>


<script type="text/javascript">
import DetailCard from './DetailCard';

export default {
  props: {
    layout: {
      default: () => ({sections:[]})
    },
    glanceData:{ default: () => ({}) },
    header: { default: () => ({ label:'', heading:[] }) }
  },
  computed: {
    displayHeader: function(){
      let heading = '';
      for (var header of this.header.heading) {
        heading += this.glanceData[header] + ' ';
      }
      return heading;
    }
  },
  components: {
    DetailCard
  }
};
</script>


<style lang="scss" scoped>
@import "../css/mixins";
@import "../css/constants";
.glance{
  background-color: white;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.section-body {
  display: flex;
  flex-wrap: wrap;
}

.section-property-block {
  margin-right: $p16;
  margin-bottom: $p16;
  min-width: 140px;
}
.section-property-title {
    color: $gray5;
    font-family: 'Hind Light', sans-serif;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: $p14;
    line-height: $p14;
}
.section-property-container {
  height: $p32;
}
.section-property {
    color: $gray7;
    border:none;
    font-family: 'Hind Regular';
    word-wrap: break-word;
}
div.header{
  // margin-bottom: 25px;
}
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Glance.vue